@let corpDesign =
  siteContextService.isShopContext()
    ? corporateDesignService.corporateDesign
    : signal(undefined);
<button
  [ngClass]="[
    'rounded-md',
    corpDesign() ? 'disabled:cursor-not-allowed enabled:hover:brightness-88 enabled:active:brightness-76' : defaultButtonColour(),
    style() === 'custom' || style() == 'tertiary'
      ? (this.corporateDesignService.isDarkModeActive() ? 'text-standard-text-dark' : '')
      : 'enabled:active:outline-1 enabled:active:outline-solid',
    style() === 'tertiary'
      ? 'py-3 px-4'
      : buttonSize() === 'small'
        ? 'px-3 py-1'
        : buttonSize() === 'quadratic'
          ? 'px-1 py-1'
          : 'p-input',
  ]"
  [class.tertiary-button]="style() === 'tertiary'"
  [style.--tertiary-background-color]="corporateFontColor() || null"
  [ngStyle]="{
    color: corporateFontColor(),
    background: corporateBackgroundColor(),
    borderColor: corporateBorderColor(),
    borderBottomRightRadius: flattenRightSide()
      ? 0
      : corpDesign()
        ? corpDesign()!.buttonBorderRounding + 'px'
        : undefined,
    borderTopRightRadius: flattenRightSide()
      ? 0
      : corpDesign()
        ? corpDesign()!.buttonBorderRounding + 'px'
        : undefined,
    borderBottomLeftRadius: flattenLeftSide()
      ? 0
      : corpDesign()
        ? corpDesign()!.buttonBorderRounding + 'px'
        : undefined,
    borderTopLeftRadius: flattenLeftSide()
      ? 0
      : corpDesign()
        ? corpDesign()!.buttonBorderRounding + 'px'
        : undefined,
  }"
  [disabled]="isDisabled()"
  [type]="type()"
  [id]="id()"
  class="border-box relative flex w-full! cursor-pointer flex-row items-center justify-center border-1 text-[1rem] text-nowrap"
  [attr.data-testid]="id() | appendTestId: 'button'">
  <ng-content class="h-full"></ng-content>
  @if (text()) {
    <span class="h-full">{{ text() }}</span>
  }
  @if (isModalButton()) {
    <span class="material-symbols-rounded text-primary-main absolute right-3">
      edit_square
    </span>
  }
  @if (isDisabled()) {
    <span
      (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"
      class="absolute top-0 right-0 bottom-0 left-0"
      tabIndex="0"
      [attr.aria-label]="disabledText()"></span>
  }
</button>
